import { AddressPhotoField } from '@/components/shared/AddressPhotoField';

/**
 * The one photo an address carries — a shot of the building.
 *
 * Its job is downstream: a new inspection report on any job at this address
 * starts with this photo on its cover. Replacing it here changes what the *next*
 * report picks up; reports already written keep the cover they were made with.
 */
export function AddressPhotoCard({
  locationId,
  photoUrl,
}: {
  locationId: string;
  photoUrl?: string | null;
}) {
  return (
    <div className="bg-white shadow rounded-lg mb-8">
      <div className="p-6">
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-gray-900">Address Photo</h2>
          <p className="text-sm text-gray-500">
            Used as the cover photo on new inspection reports for this address.
          </p>
        </div>

        <AddressPhotoField locationId={locationId} photoUrl={photoUrl} />
      </div>
    </div>
  );
}
